import { Box, Toolbar } from "@mui/material"
import React, { useContext } from "react"
import { customPalette, theme } from "../../../../theme"
import { BSVariantContext } from "../../../core/context/beem-shot/BSVariant/BSVariantContext"
import { AppNavBarContext } from "../../../core/context/nav-bar/AppNavBarContext"
import { ProjectContext } from "../../../core/context/project/ProjectContext"
import { stringToDate } from "../../../core/services/date-service"
import { BSVariantStatusChip } from "../../badges/BSVariantStatusChip"
import { BackButtonNavbar } from "../../buttons/back-button/BackButtonNavbar"
import { ProjectCardStatus } from "../../card/beem-master/project-status-card"
import { CreatedByDisplayer } from "../../CreatedByDisplayer"
import { DefaultTypography } from "../../typography/default-typography"

export function BSVariantHeader(): React.JSX.Element {
  const { showProjectStatus, title } = useContext(AppNavBarContext)
  const { project } = useContext(ProjectContext)
  const { selectedVariant } = useContext(BSVariantContext)

  return (
    <Toolbar
      sx={{
        border: 1,
        color: customPalette.white,
        borderRadius: 5,
        backgroundColor: customPalette.dark1,
        ...theme.mixins.toolbar,
      }}>
      <Box sx={{ display: "flex" }}>
        <BackButtonNavbar />
        <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", gap: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", pl: 1, gap: 1 }}>
            <DefaultTypography label={title} fontWeight={600} color="white" />
            {showProjectStatus && project?.status && <ProjectCardStatus status={project?.status} />}

            {selectedVariant && <BSVariantStatusChip status={selectedVariant?.variantStatus} />}
          </Box>
          {selectedVariant && (
            <CreatedByDisplayer
              createdByUser=""
              department=""
              lastModifiedDate={stringToDate(selectedVariant.lastModifiedDate)}
              isForNavbar
            />
          )}
        </Box>
      </Box>
    </Toolbar>
  )
}
